export class PatientHealthcareAgreement {
    public idPatientHealthcareAgreement: number;
    public idUserPatient: number;
    public idHealthcareAgreement: number;
    public idHealthcareAgreementPlan: number;
    public healthcareAgreementCardNumber: string;
    public healthcareAgreementExpirationDate: Date;
    public datetimeInclusion: Date;
}